import type { SampleOrderDemand } from '../../types';

import { randNumber } from '@ngneat/falso';

import { mockSampleOrderDemandOption } from './mockSampleOrderDemandOption';

/**
 * Returns a mocked SampleOrderDemand with two sample-flagged options by default.
 * Override `styleOptions` for a specific option count (including an empty list).
 */
const mockSampleOrderDemand = (
    overwrite?: Partial<SampleOrderDemand>
): SampleOrderDemand => ({
    styleNumber: randNumber({ min: 12000000, max: 12999999 }),
    styleOptions: [
        mockSampleOrderDemandOption(),
        mockSampleOrderDemandOption(),
    ],
    ...overwrite,
});

export { mockSampleOrderDemand };
